import React from 'react';
import Dropzone from 'react-dropzone';
import { Grid } from '@mui/material';

import MDTypography from '@components/MDTypography';

const MDDropzone = (props: any) => {
  const {
    onFileSelect,
    accept,
    multiple = false,
    width = '100%',
    height = 100,
    padding = '10px',
    border = 'solid 1px #D3D3D3',
    borderRadius = 9,
    disabled
  } = props;

  return (
    <Dropzone
      onDrop={onFileSelect}
      accept={accept}
      multiple={multiple}
      disabled={disabled}
    >
      {({ getRootProps, getInputProps }) => (
        <Grid
          {...getRootProps({
            style: {
              height,
              width,
              border,
              borderRadius,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: disabled ? 'default' : 'pointer',
              padding
            }
          })}
        >
          <input {...getInputProps()} />
          <MDTypography
            sx={{ textAlign: 'center', color: '#808080' }}
            fontSize='12px'
            opacity={disabled ? 0.5 : 1}
          >
            Drag and drop .csv or .xls / .xlsx file or click here to select file
            from Computer
          </MDTypography>
        </Grid>
      )}
    </Dropzone>
  );
};

export default MDDropzone;
